import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import styled from 'styled-components'
import {
	EmailInput,
	TextInput
} from '../../../../../components/form-components/inputs.component'
import Yup from './../../../../../helpers/custom-yup'

const schema = Yup.object().shape({
	name: Yup.string()
		.name()
		.required('Informe o nome completo'),
	email: Yup.string()
		.emailMoveflex()
		.email('E-mail inválido')
		.required('Informe o e-mail'),
	emailConfirmation: Yup.string()
		.equalTo(Yup.ref('email'), 'Os e-mails digitados não conferem')
		.required('Informe a confirmação do e-mail')
})

const StyledForm = styled.div`
	padding: 1rem 0 2.4rem;
`

const StyledInputContainer = styled.div`
	margin-top: 4rem;
`

class UserFormComponent extends Component {
	constructor(props) {
		super(props)
		this.nameRef = React.createRef()
		this.emailRef = React.createRef()
		this.emailConfirmationRef = React.createRef()
	}

	submit() {
		this.refs.form.submitForm()
		setTimeout(() => {
			const errors = this.refs.form.state.errors
			if (errors && Object.keys(errors).length) {
				const id = Object.keys(errors)[0]
				const ref = this[`${id}Ref`]

				if (!ref || !ref.current) return

				const element =
					ref.current.element || ref.current.input || ref.current
				element.focus()
			}
		}, 0)
	}

	render() {
		const { initialValues, onSubmit } = this.props
		return (
			<Formik
				ref="form"
				initialValues={initialValues}
				onSubmit={onSubmit}
				validationSchema={schema}
				render={props => (
					<Form noValidate>
						<StyledForm>
							<TextInput
								elementRef={this.nameRef}
								id="name"
								label="Nome *"
								maxLength={128}
								autoFocus={true}
								{...props}
							/>
							<StyledInputContainer>
								<EmailInput
									elementRef={this.emailRef}
									id="email"
									label="E-mail *"
									{...props}
								/>
							</StyledInputContainer>
							<StyledInputContainer>
								<EmailInput
									elementRef={this.emailConfirmationRef}
									id="emailConfirmation"
									label="Confirme o E-mail *"
									{...props}
								/>
							</StyledInputContainer>
						</StyledForm>
					</Form>
				)}
			/>
		)
	}
}

export default UserFormComponent
